import { render, staticRenderFns } from "./buildingPanel.vue?vue&type=template&id=59ae946d&"
import script from "./buildingPanel.vue?vue&type=script&lang=js&"
export * from "./buildingPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports